/**
 * Restzeit einer Deadline - "noch 3 Tage", "überfällig seit 2 Tagen" (F-09).
 *
 * Ueberfaellig ist deutlich rot, heute und bald bernstein, spaeter ruhig.
 * Die Bedeutung steht immer auch als Text da, nie nur als Farbe (F-21).
 */
import { Flag, TriangleAlert } from 'lucide-react';

import { deadlineStatus } from '@/domain/deadlines';
import { formatDate, now } from '@/lib/datetime';
import { cn } from '@/lib/utils/cn';
import type { LocalDate } from '@/domain/types';

const TON = {
  ueberfaellig: 'bg-danger/15 text-danger font-medium',
  heute: 'bg-warn/15 text-warn font-medium',
  bald: 'bg-warn/10 text-warn',
  spaeter: 'bg-surface-raised text-ink-muted',
} as const;

export function DeadlineBadge({ date, time, className }: {
  date: LocalDate;
  time?: string;
  className?: string;
}) {
  const s = deadlineStatus(date, time, now());
  const genau = `${formatDate(date)}${time ? `, ${time}` : ''}`;

  return (
    <span
      title={`Deadline: ${genau}`}
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[11px] tabular-nums',
        TON[s.state],
        className,
      )}
    >
      <Flag className="size-3" aria-hidden="true" />
      <span>{s.label}</span>
      <span className="sr-only">(Deadline {genau})</span>
    </span>
  );
}

/** Hinweis auf widerspruechliche Fristen - Warnung, keine Sperre (F-09). */
export function DeadlineWarnung({ children }: { children: React.ReactNode }) {
  return (
    <p role="note" className="flex items-start gap-1.5 text-[12px] text-warn">
      <TriangleAlert className="mt-0.5 size-3.5 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
